import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { UserService } from '../../_services/user.service';
import { ApiService } from '../../_services/api.service';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-phone-number-authentication',
  templateUrl: './phone-number-authentication.component.html',
  styleUrls: ['./phone-number-authentication.component.css']
})
export class PhoneNumberAuthenticationComponent implements OnInit {

  @ViewChild('f') public form: NgForm;
  user: any;
  registerModel: any = { day: 'Gün', month: 'Ay', year: 'Yıl' };
  loading: boolean;
  lastUser;
  isCodeSent: boolean;
  dontSms = false;
  isInvalidPhoneNumber: boolean;
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  isInvalidCode: boolean;

  private subscription: Subscription = new Subscription();
  constructor(
    private http: Http,
    private zone: NgZone,
    private afs: AngularFirestore,
    private scriptLoader: ScriptLoaderService,
    private router: Router,
    private phoneAuthService: PhoneAuthenticationService,
    private userService: UserService,
    private apiService: ApiService,
    private httpclient: HttpClient
  ) {
    this.subscription.add(this.afs.collection('users').doc(localStorage.getItem('currentUserId')).valueChanges().subscribe(user => {
      this.user = user;
    }));
  }

  ngOnInit() {
  }
  save() {
    this.loading = true;
    if (!this.isCodeSent) {
      this.phoneAuthService.sendOtp(this.registerModel.phoneNumber)
        .then(res => {
          this.loading = false;
          this.isCodeSent = true;
          // this.form.control.get("phoneNumber").setErrors(null);
          this.isInvalidPhoneNumber = false;
        }).catch(err => {
          // this.username.control.setErrors({ 'invalidPhoneNumber': true });
          // this.form.control.get("phoneNumber").setErrors({ invalidPhoneNumber: true });
          this.isInvalidPhoneNumber = true;

          this.loading = false;
        });
      return;
    }
    if (!this.phoneAuthService.confirm(this.registerModel.code)) {
      this.isInvalidCode = true;
      this.loading = false;
      return;
    }
    this.isInvalidPhoneNumber = false;
    let update = {};
    const id = localStorage.getItem("currentUserId");
    this.afs.collection('users').doc(id).update({
      phoneNumber: this.registerModel.phoneNumber,
      isNewRegistered: false
    })
      .then(() => this.scriptLoader.load('body', 'assets/js/adwords-analytics.js'))
      .then(() => {
        this.zone.run(() => {
          this.subscription = this.userService.getUser().subscribe(elem => {
            this.lastUser = elem;
          })


          var users = {
            userKey: id,
            agreement: this.lastUser.agreement || null,
            birthday: this.dateFormat(new Date(this.lastUser.birthday.year + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
            totalPoint: this.lastUser.point.totalPoint || null,
            username: this.lastUser.username,
            email: this.lastUser.email,
            firstname: this.lastUser.firstname,
            isEmailVerified: this.lastUser.isEmailVerified || null,
            isSecret: this.lastUser.isSecret || null,
            joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
            lastname: this.lastUser.lastname,
            level: this.lastUser.level,
            city: this.lastUser.city || null,
            phoneNumber: this.registerModel.phoneNumber || null,
            education: this.lastUser.education || null,
            gender: this.lastUser.gender || null,
            job: this.lastUser.job || null,
            profileImage: this.lastUser.profileImage || null,
            following: this.lastUser.following ? this.lastUser.following.length : 0,
            followers: this.lastUser.followers ? this.lastUser.followers.length : 0
          }
          const option = {
            data: {
              customToken: id,
              email: this.lastUser.email,
              firstname: this.lastUser.username,
              name: this.lastUser.firstname
            }
          }

          this.request(option);
          this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(a => a);
          this.router.navigate(['/home']);


        });
      });
  }
  request(option) {

    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendWelcomenew', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  notSend() {

    this.dontSms = true;
    this.isCodeSent = false;

  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/phone-number-authentication/phone-number-authentication.component.ts